import {globalSettings} from "../globalSettings";
import {html} from "lit";

const meta = {
	title: "Notification/Proving Grounds",

	render: ({customSettingsUrl, locale, stage, updateMode, debug}) =>
		html` <fragment>
			<a data-name="notifications">
				<span class="ux-iws-navigation-meta__icon-box">
					<uxn-notification-bell />
				</span>
				<span class="ux-iws-navigation-meta__link-text">Notifications</span>
			</a>
			<hr />
			<ux-tooltip tooltip-target="a[data-name='notifications']" align="bottom">
				<uxn-notification-center
					custom-settings-url="${customSettingsUrl}"
					locale="${locale}"
					stage="${stage}"
					updateMode="${updateMode}"
					debug="${debug}"
				></uxn-notification-center>
			</ux-tooltip>
			<uxn-notification-settings locale="${locale}" stage="${stage}" debug="${debug}" />
		</fragment>`,

	argTypes: {
		customSettingsUrl: {control: "text"},
		locale: {control: "text"},
		stage: {control: "select", options: ["PROD", "QA", "INT"]},
		updateMode: {control: "select", options: ["poll", "stream"]},
		debug: {control: "boolean"},
	},
};

export default meta;

export const Default = {
	args: {
		customSettingsUrl: "",
		locale: globalSettings.locale,
		stage: globalSettings.stage,
		updateMode: "poll", // "stream"
		debug: globalSettings.debug,
	},
};
